<template>
    <v-chart :options="options" v-if="options.series.length > 0"></v-chart>
</template>

<script>
export default {
    data() {
        return {
            options: {
                title: {
                    text: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    // type: 'scroll',
                },
                dataset: {
                    dimensions: [],
                    source: [],
                },
                xAxis: {
                    type: "category",
                    name: "时间",
                },
                yAxis: {
                    name: "",
                },
                dataZoom: [
                    {
                        type: 'slider',
                        show: true,
                        xAxisIndex: [0],
                        startValue: "",
                        endValue: ""
                    },
                    {
                        type: 'inside',
                        xAxisIndex: [0],
                        startValue: "",
                        endValue: ""
                    },
                ],
                series: []
            }
        }
    },
    props: {
        "dataSet": Object,
        "chartName": String,
        "yName": String,
        "seriesType": String
    },
    methods: {
        setOptions(){
            this.options.title.text = this.chartName;
            this.options.yAxis.name = this.yName;
            this.options.dataset = this.dataSet;
            let series = [];
            for (let item of this.dataSet.dimensions) {
                if(item != "time"){
                    series.push({type: this.seriesType})
                }
            }
            this.options.dataZoom.map(() => {})
            for (let item of this.options.dataZoom) {
                item.startValue = this.dataSet.source[0].time;
                item.endValue = this.getEndValue(this.dataSet.source[0].time);
            }
            this.options.series = series;
        },
        getEndValue(val){
            let start_time = new Date(val),
            end_time = new Date(start_time.setDate(start_time.getDate()+6)),
            y = end_time.getFullYear(),
            m = end_time.getMonth()+1,
            d = end_time.getDate();
            m = m < 10 ? "0" + m: m;
            d = d < 10 ? "0" + d: d;
            return y + "-" + m + "-" + d
        }
    },
    watch: {
        dataSet: {
            handler: "setOptions",
            immediate: true
        }
    },
}
</script>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>